import type { TInsuranceTypeListItem } from '~/interfaces';

export const InsuranceType: TInsuranceTypeListItem[] = [
  {
    id: 'Auto/auto',
    label: 'Auto',
    product: 'Auto',
    type: 'auto',
    c: 'C20029',
  },
  {
    id: 'Home/home',
    label: 'Home',
    product: 'Home',
    type: 'home',
    c: 'C20030',
  },
  {
    id: 'Home/renter',
    label: 'Renters',
    product: 'Home',
    type: 'renter',
    c: 'C31585',
  },
] as const;
